
/**
 * 会員限定処理
 */
!(function (ns) {
  /**
   * urlの文字列からドメインを取得
   * @param {string} url
   * @return {string}
   */
  function getDomain(url) {
    let domain;
    if (!url) {
      return '';
    }
    if (url.indexOf('://') > -1) {
      domain = url.split('/')[2];
    } else {
      domain = url.split('/')[0];
    }
    domain = domain.split(':')[0];
    domain = domain.split('?')[0];
    return domain;
  }

  /**
   * memberonlyオブジェクト
   */
  const mo = {};

  /**
   * リファラーを確認して会員限定かどうかを確認する
   *
   * 特定のリファラー経由の場合trueになり、localStorageにデータを保存する
   * localStorageに保存されたデータは7日間有効
   *
   * localStorageにデータがなかったり、リファラーが違う場合はfalseになる
   *
   * @param {Array<string>} referrerUrlList
   * @return {Boolean}
   */
  mo.isMemberReferrer = function (referrerUrlList) {
    if (!referrerUrlList || referrerUrlList.length == 0) {
      return false;
    }

    const storageUrlKey = 'referrerUrl';
    const storageDateKey = 'referrerDate';
    // const expiration = 7;
    const expiration = 1;

    // 対象となるドメインを取り出す
    const referrerDomain = getDomain(document.referrer);
    const storageDomain = getDomain(localStorage.getItem(storageUrlKey));

    // ドメインリストを作成
    const validateDomainList = referrerUrlList.map(function (url) { return getDomain(url) });

    // リファラーが認証ページ経由の場合はstorageを更新してtrue
    const isValidDomain = validateDomainList.some(function (domain) { return referrerDomain === domain });
    if (isValidDomain) {
      const now = new Date();
      now.toISOString();
      localStorage.setItem(storageUrlKey, referrerDomain);
      localStorage.setItem(storageDateKey, now.toISOString());
      return true;
    }

    // ストレージに保存されているリファラーURLが対象のドメインに一致しているかどうか
    const isValidStorageDomain = validateDomainList.some(function (domain) { return storageDomain === domain });
    if (isValidStorageDomain) {
      const storageDateValue = localStorage.getItem(storageDateKey);
      if (storageDateValue) {
        // 日付が保存されている場合
        const targetDate = new Date(storageDateValue);
        const baseDate = new Date();
        baseDate.setDate(baseDate.getDate() - expiration);
        if (targetDate >= baseDate) {
          // 日付が有効ならtrue
          return true;
        } else {
          // 無効なら削除してfalse
          localStorage.removeItem(storageUrlKey);
          localStorage.removeItem(storageDateKey);
          return false;
        }
      } else {
        return false;
      }
    }

    return false;
  }

  // 有効期限までの残り時間を表示する関数
  mo.showRemainingHours = function () {
    const storageDateKey = 'referrerDate';
    // const expirationHours = 7 * 24; // 7日 = 168時間
    const expirationHours = 1 * 24; // 1日 = 24時間

    const storageDateValue = localStorage.getItem(storageDateKey);
    if (storageDateValue) {
      const storedDate = new Date(storageDateValue);
      const now = new Date();

      const diffMs = now - storedDate;
      const diffHours = diffMs / (1000 * 60 * 60);
      const remainingHours = Math.max(0, expirationHours - diffHours);

      console.log(`会員限定の有効期限はあと約 ${remainingHours.toFixed(1)} 時間です`);
    } else {
      console.log('会員限定データは保存されていません');
    }
  };

  ns.mo = mo;
})(window);
